import { render } from "./DeliveryDuel.vue?vue&type=template&id=53807e48&scoped=true"
import script from "./DeliveryDuel.vue?vue&type=script&lang=js"
export * from "./DeliveryDuel.vue?vue&type=script&lang=js"

import "./DeliveryDuel.vue?vue&type=style&index=0&id=53807e48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53807e48"]])

export default __exports__